//LL: 07.08.23: copy of Charts/components/ChartCustomStylesField

import * as React from 'react';
import * as _ from 'underscore';

import StringField from '../../../../_common/platform/tsx/StringField';
import NumberSpinnerExtended from '../../../../_common/platform/tsx/NumberSpinnerExtended';
import { ColorBoxField } from '../../../../_common/platform/tsx/ColorBoxField';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import SelectField from '../../../../_common/platform/tsx/SelectField';

import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import GlobalState from '../../../../_common/platform/ts/globalStates/GlobalState';
import { NullHandling } from '../../../../_common/platform/ts/nullHandling';
import { ATTRIBUTE_SEPARATOR, EntityModelsStore } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';

//LL: 24.06.24:
import { convertIntervalValueToAttrQueryParam, IMappingValue } from '../../../../_common/platform/tsx/IntervalsSelect';

import { AlignmentType, AGGREGATIONS } from '../../../../_common/platform/ts/ConfigurationConstants';

import * as Config from '../config';

import * as Validators from './Validators';

import * as appTheme from '../../../../_common/platform/ts/appTheme';

class CalendarMarkersFieldRow extends React.Component<any, any> {
    constructor(props) {
        super(props);
        //   themeObj={self.props.themeObj}
    }

    normalize(value) {
        if (value.name == null) {
            //LL: but name is not set to null now, to '' by attrValue
            delete value.attrValue;
            delete value.label;
            delete value.symbol;
            delete value.useSymbolColor;
            delete value.symbolColor;
            delete value.useBorderColor;
            delete value.borderColor;
            //pattern: 'diagonalLeft', patternBackColor: 'transparent', patternColor: 'coral'
            delete value.lineWidth;

            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}
    }

    processAttrValueChange = (val) => {
        let obj: any = _.clone(this.props.value || {});

        delete obj.label;

        if (val === 'none') {
            delete obj.isDefault;
            delete obj.attrValue;
            obj.name = '';
        } else if (val === 'default') {
            obj.isDefault = true;
            obj.attrValue = val;
            obj.name = val;
        } else {
            delete obj.isDefault;
            obj.attrValue = val;

            let evcExternal = this.props.entityCollectionExternal;
            if (Config.UseExternalDataQueryForPeriodTypes === true) {
                if (evcExternal != null && evcExternal.labels != null) {
                    let fnd: any = _.find(evcExternal.labels, function (labelObj: any) {
                        return labelObj.value.toString() === val;
                    });
                    obj.label = fnd != null ? fnd.label : null; //'';
                }

                if (evcExternal != null && evcExternal.displayValues != null) {
                    let fnd = _.find(evcExternal.displayValues, (a: any, i) => {
                        return a.value.toString() === val;
                    });
                    obj.name = fnd != null ? fnd.displayValue : '';
                }
            } else {
                let evc = this.props.entityValueCollection;
                if (evc != null && evc.displayValues != null) {
                    let fnd = _.find(evc.displayValues, (a: any, i) => {
                        return a.value === val;
                    });
                    obj.name = fnd != null ? fnd.displayValue : '';
                }
            }

            //let evc = this.props.entityValueCollection;
            //if (evc != null && evc.displayValues != null) {
            //    let fnd = _.find(evc.displayValues, (a:any, i) => {
            //        return (a.value === val);
            //    });
            //    obj.name = fnd != null ? fnd.displayValue : '';
            //}
        }

        this.handleValueChange(obj);
    };

    //LL: r/o, set by AttrValue   Don't rem
    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };
    //LL: it is on AttrValue
    processNameClick = (e) => {
        let obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    };

    processLabelChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.label = val;
        this.handleValueChange(obj);
    };

    processSymbolChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.symbol = val;
        this.handleValueChange(obj);
    };

    processUseSymbolColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.useSymbolColor = val;
        this.handleValueChange(obj);
    };

    processSymbolColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.symbolColor = val;
        this.handleValueChange(obj);
    };

    processUseBorderColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.useBorderColor = val;
        this.handleValueChange(obj);
    };

    processBorderColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.borderColor = val;
        this.handleValueChange(obj);
    };

    processPatternColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.patternColor = val;
        this.handleValueChange(obj);
    };

    processLineWidthChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.lineWidth = val;
        this.handleValueChange(obj);
    };

    processPatternChange = (val) => {
        let obj: any = _.clone(this.props.value || {});
        if (val === 'none') {
            delete obj.pattern;
        } else {
            obj.pattern = val;
        }
        this.handleValueChange(obj);
    };

    handleValueChange(value) {
        this.normalize(value);

        //LL: changed => not inherited
        delete value.inherited;

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton(value) {
        if (value.name == null) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    getAttrValue(value) {
        let displayVal = value.attrValue || '';

        //  onClick={this.processNameClick}
        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processNameClick}>
                    {'Add'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        let evcExternal = this.props.entityCollectionExternal;
        if (Config.UseExternalDataQueryForPeriodTypes === true) {
            if (evcExternal != null && evcExternal.displayValues != null) {
                //  none ?  not_set ? - below
                const options = _.map(evcExternal.displayValues, (obj: any, i) => {
                    return (
                        <option key={obj.value + '-' + i} value={obj.value}>
                            {obj.displayValue}
                        </option>
                    );
                });

                return (
                    <SelectField value={displayVal} onChange={this.processAttrValueChange}>
                        <option key="none" value="none">
                            {'none'}
                        </option>
                        <option key="default" value="default">
                            {'default'}
                        </option>
                        {options}
                    </SelectField>
                );
            } else {
                return <StringField readOnly={true} onChange={null} value={'no values'} />;
            }
        }

        let evc = this.props.entityValueCollection;
        if (evc != null && evc.displayValues != null) {
            //  none ?  not_set ? - below
            const options = _.map(evc.displayValues, (obj: any, i) => {
                return (
                    <option key={obj.value + '-' + i} value={obj.value}>
                        {obj.displayValue}
                    </option>
                );
            });

            return (
                <SelectField value={displayVal} onChange={this.processAttrValueChange}>
                    <option key="none" value="none">
                        {'none'}
                    </option>
                    <option key="default" value="default">
                        {'default'}
                    </option>
                    {options}
                </SelectField>
            );
        } else {
            return (
                <StringField
                    readOnly={true}
                    onChange={null}
                    value={'no values'}
                    //applyOnEnter={true}
                    //changeOnBlurOnly={true}
                />
            );
        }
    }

    //LL: Name is read-only
    getName(value) {
        let displayVal = value.name || '';

        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processNameClick}>
                    {'Add (not implemented)'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    getLabel(value) {
        if (value.name == null) {
            return;
        }

        //LL: entityCollectionExternal Config.UseExternalDataQueryForPeriodTypes === true
        let evcExternal = this.props.entityCollectionExternal;
        if (Config.UseExternalDataQueryForPeriodTypes === true) {
            let displayVal = value.label;
            if (displayVal == null) {
                if (evcExternal != null && evcExternal.labels != null) {
                    let attrValue = value.attrValue;
                    if (attrValue != null) {
                        let fnd: any = _.find(evcExternal.labels, function (labelObj: any) {
                            return labelObj.value.toString() === attrValue;
                        });
                        if (fnd != null) {
                            displayVal = fnd.label;
                        }
                    }
                }
            }
            if (displayVal == null) {
                displayVal = '';
            }

            // allowNull={false} ???
            return (
                <StringField
                    onChange={this.processLabelChange}
                    value={displayVal}
                    allowNull={true}
                    applyOnEnter={true}
                    changeOnBlurOnly={true}
                />
            );
        }

        let displayVal = value.label || '';
        return (
            <StringField
                onChange={this.processLabelChange}
                value={displayVal}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    getSymbol(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.symbol || '';
        return (
            <StringField
                onChange={this.processSymbolChange}
                value={displayVal}
                allowNull={true}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    getUseSymbolColor(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.useSymbolColor || false;
        return <BooleanField onChange={this.processUseSymbolColorChange} value={displayVal} allowNull={false} />;
    }

    getSymbolColor(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.symbolColor || null;
        return (
            <ColorBoxField
                onChange={this.processSymbolColorChange}
                value={displayVal}
                themeObj={this.props.themeObj}
                hideTransparency={true}
                showText={true}
                glob={this.props.glob}
            />
        );
    }

    getUseBorderColor(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.useBorderColor || false;
        return <BooleanField onChange={this.processUseBorderColorChange} value={displayVal} allowNull={false} />;
    }

    getBorderColor(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.borderColor || null;
        return (
            <ColorBoxField
                onChange={this.processBorderColorChange}
                value={displayVal}
                themeObj={this.props.themeObj}
                hideTransparency={true}
                showText={true}
                glob={this.props.glob}
            />
        );
    }

    getPatternColor(value) {
        //LL: it is Fore color, Back will be Transparent
        if (value.name == null) {
            return;
        }

        let displayVal = value.patternColor || null;
        return (
            <ColorBoxField
                onChange={this.processPatternColorChange}
                value={displayVal}
                themeObj={this.props.themeObj}
                hideTransparency={false}
                showText={true}
                glob={this.props.glob}
            />
        );
    }

    getLineWidth(value) {
        //LL: for patterns
        if (value.name == null) {
            return;
        }

        let displayVal = value.lineWidth || 4;
        return (
            <NumberSpinnerExtended
                value={displayVal}
                allowNull={false}
                integer={true}
                min={2}
                max={16}
                step={2}
                onChange={this.processLineWidthChange}
            />
        );
    }

    //LL:  patterns   pattern: 'diagonalLeft', patternBackColor: 'transparent', patternColor: 'coral'
    //  See Gantt/PatternManager
    getPattern(value) {
        if (value.name == null) {
            return;
        }

        //let displayVal = value.pattern || Config.defaultPattern;
        let displayVal = value.pattern || null;

        const options = _.map(Config.PatternList, (p: any, key) => {
            return (
                <option key={key} value={key}>
                    {p.text}
                </option>
            );
        });

        return (
            <SelectField value={displayVal} onChange={this.processPatternChange}>
                <option key="none" value="none">
                    {'none'}
                </option>
                {options}
            </SelectField>
        );
    }

    getMarkerView(value) {
        if (value.name == null) {
            return;
        }

        //LL: either Symbol or Pattern <=================================

        //  see const getLegendItem = (type, text, color) in CalendarGrid   must be common function
        let divPict;
        //let divPictStyle: any = {width: '16px', height: '16px'};
        let divPictStyle: any = { width: '1.8em', height: '1.8em', overflow: 'hidden' };

        //let color = value.borderColor || 'black';
        let color = value.borderColor;

        let colorSymbol;
        if (value.useSymbolColor === true) {
            colorSymbol = value.symbolColor;
        }

        let pattern = value.pattern;
        let colorPattern = value.patternColor;

        let lineWidth = value.lineWidth;

        if (pattern != null && colorPattern != null) {
            //LL: as below:
            let divContainerStyle: any = {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                padding: '2px',
                breakInside: 'avoid'
            };

            if (value.useBorderColor === true && color != null) {
                // value.borderColor
                divPictStyle['border'] = color + ' 3px solid';
            }

            //width={'1.8em'}
            //height={'1.8em'}
            //width={16}
            //height={16}
            //divPict =
            //    <div style={divPictStyle}>
            //        <CanvasComponent
            //            width={18}
            //            height={18}
            //            pattern={pattern}
            //            colorPattern={colorPattern}
            //        />
            //    </div>;

            //LL:  in samples: last "cyan" is background color if needed
            //  vertical line
            //elem.css("background", "linear-gradient(to right,transparent calc(50% - 3px),red calc(50% - 3px) calc(50% + 3px), transparent calc(50% + 3px)), cyan");
            //  horizontal line
            //elem.css("background", "linear-gradient(to bottom,transparent calc(50% - 3px),red calc(50% - 3px) calc(50% + 3px), transparent calc(50% + 3px)), cyan");
            // elem.css("background", "linear-gradient(to bottom right,transparent calc(50% - 3px),red calc(50% - 3px) calc(50% + 3px), transparent calc(50% + 3px)), linear-gradient(to bottom left,transparent calc(50% - 3px),red calc(50% - 3px) calc(50% + 3px), transparent calc(50% + 3px)), cyan");
            //let background: any = "linear-gradient(to bottom right,transparent calc(50% - 3px),red calc(50% - 3px) calc(50% + 3px), transparent calc(50% + 3px)), linear-gradient(to bottom left,transparent calc(50% - 3px),red calc(50% - 3px) calc(50% + 3px), transparent calc(50% + 3px)), cyan";

            let background = Validators.getBackgroundGradient(pattern, colorPattern, lineWidth);
            divPictStyle['background'] = background;

            if (value.symbol != null && value.symbol != '') {
                divPictStyle['lineHeight'] = '1.5em';
                divPictStyle['textAlign'] = 'center';
                if (colorSymbol != null) {
                    divPictStyle['color'] = colorSymbol;
                }
                divPict = <div style={divPictStyle}>{value.symbol}</div>;
            } else {
                divPict = <div style={divPictStyle}></div>;
            }

            //LL: as below:
            return (
                <div className="form-control" style={divContainerStyle}>
                    {divPict}
                </div>
            );
        }

        //enum MarkerType {
        //    SymbolAndBorder = 0,
        //    Border,
        //    Background
        //}

        let type: string = ''; // type: xb, b, bg
        if (value.symbol != null && value.symbol != '') {
            type = 'x';
        }
        if (value.useBorderColor === true) {
            type += 'b';
        }

        switch (type) {
            case 'x': // X without border
                divPictStyle['border'] = 'lightgray 1px dotted';
                divPictStyle['lineHeight'] = '1.5em';
                divPictStyle['textAlign'] = 'center';
                if (colorSymbol != null) {
                    divPictStyle['color'] = colorSymbol;
                }
                divPict = <div style={divPictStyle}>{value.symbol}</div>;
                break;
            case 'xb': // X and border
                divPictStyle['border'] = color + ' 3px solid';
                divPictStyle['lineHeight'] = '1.2em'; // '12px';
                divPictStyle['textAlign'] = 'center';
                if (colorSymbol != null) {
                    divPictStyle['color'] = colorSymbol;
                }
                divPict = <div style={divPictStyle}>{value.symbol}</div>;
                break;
            case 'b': // border
                divPictStyle['border'] = color + ' 3px solid';
                divPict = <div style={divPictStyle}></div>;
                break;
            case 'bg': // background  (for Empty, no here)
                divPictStyle['backgroundColor'] = color;
                divPict = <div style={divPictStyle}></div>;
                break;
        }

        let divContainerStyle: any = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            padding: '2px',
            breakInside: 'avoid'
        };

        //let text = '';
        // <span style={{marginLeft: '6px'}}>{text}</span>
        //LL: flex here historically, when with text
        return (
            <div className="form-control" style={divContainerStyle}>
                {divPict}
            </div>
        );
    }

    getRow0(value) {
        //  only "remove", "name"  - was

        //LL: 08.08.23: Calendar
        //builtinMarkers: [
        //    {
        //        name: 'Sygd 1', code: 's1',  //label: '' ?
        //        useBorderColor: true, borderColor: 'green',
        //        symbol: 'y', useSymbolColor: false, symbolColor: 'blue',
        //        pattern: 'diagonalLeft', patternBackColor: 'transparent', patternColor: 'coral'
        //    }
        //]

        let header;
        //<th className="cell-name">Name</th>
        //<th className="cell-label">Label</th>

        let periodTypeHeaderTxt = 'Period Type (Attribute Value)';
        if (Config.UseExternalDataQueryForPeriodTypes === true) {
            periodTypeHeaderTxt = 'Period Type';
        }

        let periodLabelHeader =
            Config.UseExternalDataQueryForPeriodTypes === true ? <th className="cell-label">Period Label</th> : null;

        if (value.name != null) {
            header = (
                <thead>
                    <tr>
                        <th className="cell-remove"></th>
                        <th className="cell-attrValue">{periodTypeHeaderTxt}</th>
                        {periodLabelHeader}
                    </tr>
                </thead>
            );
        }

        //<td className="cell-name ">{this.getName(value)}</td>
        //<td className="cell-label ">{this.getLabel(value)}</td>

        let periodLabelElem =
            Config.UseExternalDataQueryForPeriodTypes === true ? (
                <td className="cell-label ">{this.getLabel(value)}</td>
            ) : null;

        let body = (
            <tbody>
                <tr>
                    <td className="cell-remove">{this.getRemoveButton(value)}</td>
                    <td className="cell-attrValue">{this.getAttrValue(value)}</td>
                    {periodLabelElem}
                </tr>
            </tbody>
        );

        return (
            <table style={{ width: '100%', marginTop: '12px' }}>
                {header}
                {body}
            </table>
        );
    }

    getRow1(value) {
        //  "remove" is empty, without "name"

        let header = (
            <thead>
                <tr>
                    <th className="cell-remove"></th>
                    <th className="cell-symbol">Symbol</th>
                    <th className="cell-useSymbolColor">Use Symbol Color</th>
                    <th className="cell-symbolColor">Symbol Color</th>
                    <th className="cell-useSymbolColor">Use Border Color</th>
                    <th className="cell-symbolColor">Border Color</th>
                    <th className="cell-pattern">Pattern</th>
                    <th className="cell-patternColor">Pattern Color</th>
                    <th className="cell-lineWidth">Line Width</th>
                    <th className="cell-marker">Result Marker</th>
                </tr>
            </thead>
        );

        let body = (
            <tbody>
                <tr>
                    <td className="cell-remove"></td>
                    <td className="cell-symbol">{this.getSymbol(value)}</td>
                    <td className="cell-useSymbolColor">{this.getUseSymbolColor(value)}</td>
                    <td className="cell-symbolColor">{this.getSymbolColor(value)}</td>
                    <td className="cell-useSymbolColor">{this.getUseBorderColor(value)}</td>
                    <td className="cell-symbolColor">{this.getBorderColor(value)}</td>
                    <td className="cell-pattern">{this.getPattern(value)}</td>
                    <td className="cell-patternColor">{this.getPatternColor(value)}</td>
                    <td className="cell-lineWidth">{this.getLineWidth(value)}</td>
                    <td className="cell-marker">{this.getMarkerView(value)}</td>
                </tr>
            </tbody>
        );

        return (
            <table>
                {header}
                {body}
            </table>
        );
    }

    getRow3(value) {
        //LL: is empty

        let header = (
            <thead>
                <tr>
                    <th className="cell-remove"></th>
                </tr>
            </thead>
        );

        let body = (
            <tbody>
                <tr>
                    <td className="cell-remove"></td>
                </tr>
            </tbody>
        );

        return (
            <table style={{ marginBottom: '0.5rem' }}>
                {header}
                {body}
            </table>
        );
    }

    render() {
        let value = this.props.value || {};

        let empty = true;

        return (
            <tr style={{ borderTop: 'solid #aaaaaa 1px' }}>
                <td className="multiRows">
                    {this.getRow0(value)}
                    {this.props.empty === true ? null : this.getRow1(value)}
                    {empty ? null : this.getRow3(value)}
                </td>
            </tr>
        );
    }
}

function getState() {
    return {};
}

const GET_KEY_ATTRIBUTE_FOR_VALUES = true;

export default class CalendarMarkersField extends React.Component<any, any> {
    //LL: 23.01.25 
    private references: {
        tableBody?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        let o = this.props.options; //LL: Calendar try builtinMarkers
    }

    private startIndex;

    reorderStart = (e, ui) => {
        this.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (this.startIndex == null) {
            return;
        }

        let startIndex = this.startIndex;
        let stopIndex = $(ui.item).index();

        this.startIndex = null;

        //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");
        let tableBody = this.references.tableBody;
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        this.props.glob.AttrQueryStore.addChangeListener(this.handleEntityModelsStoreChange); //LL: for loadEntityValues

        let o = this.props.options;
        let theme = this.props.themeObj;

        //LL: for external AQ
        let attrQueryExternal = null;
        if (theme != null) {
            attrQueryExternal = theme['widget-calendar-markers-dataQuery'];

            let toApply = attrQueryExternal != null;
            if (toApply === true) {
                console.log('CalendarMarkers componentDidMount GET DATA here');
                let aqe: any = $.extend(true, {}, attrQueryExternal);
                this.loadData_PeriodTypes(aqe);
            } else {
                console.log('CalendarMarkers componentDidMount toApply NOT');
            }
        }

        let tableBody = this.references.tableBody;
        
        $(tableBody).sortable({
            axis: 'y',
            forceHelperSize: true,
            items: 'tr:not(.empty)',
            opacity: 0.8,
            handle: '.cell-name',
            cursor: 'grabbing',
            start: this.reorderStart,
            stop: this.reorderStop
        });

        let forActualCalendar = true;
        let props_values = this.get_props_values();
        if (props_values == null) {
            //props_values = {};
            forActualCalendar = false; //LL: when with standard inheritance, on upper levels
        }
        let attribute; // person.^sickness_periods.shifttype
        let dataSourceID;
        if (props_values != null) {
            let dpPeriods: any = props_values.dataProperties_Periods;
            if (dpPeriods != null) {
                dataSourceID = dpPeriods.dataSourceID;
                let aq = dpPeriods.attrQuery; // array
                if (aq != null && aq.length > 0) {
                    let fnd: any = _.find(aq, function (aqrow: any) {
                        return aqrow.role === 'ShiftType';
                    });
                    if (fnd != null) {
                        attribute = fnd.attribute;
                    }
                }
            }
        }

        let attrType;
        let attrRefEntityName = '';
        if (attribute != null) {
            // EntityModelsStore.ts
            attrType = this.props.glob.EntityModelsStore.getAttributeType(attribute, dataSourceID);
            let at = attrType; // "e"
            // getReferredEntityKeyAttributeType
            // getReferredEntity
            let attrRefEntity;
            attrRefEntity = this.props.glob.EntityModelsStore.getReferredEntity(attribute, dataSourceID);
            let at2 = attrRefEntity; //  attrRefEntity.name = 'shifttype'  -- OK
            if (attrRefEntity != null) {
                attrRefEntityName = attrRefEntity.name;
            }
        }

        if (attrRefEntityName != null && attrRefEntityName !== '') {
            this.props.glob.EntityModelsActions.loadEntityValues(dataSourceID, theme, {
                attribute: attrRefEntityName,
                loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES,
                runTimeWidgetID: undefined //EVG: I set it explicitly to show where it should be set when needed.
            });
        }

        if (dataSourceID != null) {
            // const entities:IDataLoadEntity[] =
            const entities: any[] = this.props.glob.EntityModelsStore.getEntitiesByDS(dataSourceID); // 126 shifttype-118
            let a = entities;
        }

        let dataSourceID_pre;
        let entityName_pre;
        if (!forActualCalendar) {
            if (this.props.value != null && this.props.value.length > 0) {
                let vvv = this.props.value.slice().reverse(); //LL: to find last
                let fnd = _.find(vvv, function (obj: any, i) {
                    return obj.dataSourceID != null && obj.entityName;
                });
                if (fnd != null) {
                    dataSourceID_pre = fnd.dataSourceID;
                    entityName_pre = fnd.entityName;
                }
            }
            //LL: needed at least on Application Level
            if (dataSourceID_pre == null) {
                this.props.glob.EntityModelsActions.loadModels();
            }
            if (entityName_pre != null && entityName_pre !== '') {
                this.props.glob.EntityModelsActions.loadEntityValues(dataSourceID_pre, theme, {
                    attribute: entityName_pre,
                    loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES,
                    runTimeWidgetID: undefined //EVG: I set it explicitly to show where it should be set when needed.
                });
            }
        }

        let attrQuery = null;

        this.setState({
            forActualCalendar: forActualCalendar,
            dataSourceID: dataSourceID,
            attribute: attribute,
            entityName: attrRefEntityName,
            dataSourceID_pre: dataSourceID_pre,
            entityName_pre: entityName_pre,
            attrQuery: attrQuery,
            attrQueryExternal: attrQueryExternal
        });
    }

    componentWillUnmount() {
        this.props.glob.AttrQueryStore.removeChangeListener(this.handleEntityModelsStoreChange); //LL: for loadEntityValues

        let tableBody = this.references.tableBody;
        $(tableBody).sortable('destroy');
    }

    //LL: for loadEntityValues
    handleEntityModelsStoreChange = () => {
        this.setState(this.state);
    };

    loadData_PeriodTypes(dataProperties) {
        let a = dataProperties;

        let glob = this.props.glob;
        let theme = this.props.themeObj;
        const timeZone = DateTimeFunctions.getTimeZoneFromTheme(theme);

        const GlobalStates = glob.GlobalStates;
        const globalState: GlobalState = GlobalStates != null && GlobalStates.length > 0 ? GlobalStates[0] : null;

        //LL: just try:
        //const periodFilters = globalState.getNotAppliedPeriodFilterCollection();
        //const globalFilterCollection = globalState.getAttributeFilterCollection();

        const dataSourceID = dataProperties.dataSourceID;
        //const cultureValues = this.getCultureValues();
        //const aqlParameters = this.getAQLParameters(cultureValues);
        //const scopeOptions = this.getScopeOptions();

        //this._state.loadingData = true;

        //LL: Better: with Global Filters, but set "Ignore All Global Filtering" in LocalFilter
        //LL: here with Global Filters, but I think they must not be used, so below use only Local Filter
        globalState
            .makeFiltersForWidget(
                dataSourceID,
                {
                    filters: dataProperties.attrQueryFilter,
                    globalFilterControl: dataProperties.globalFilterControl
                    //globalFilterControl: null //LL: TRY without Filters  Does not matter
                },
                0, //runTimeWidgetID,
                timeZone,
                theme,
                null, //{culture:null, ...}, //cultureValues,  null,
                {} //scopeOptions
            )
            .done((filters) => {
                //LL: Better: with Global Filters, but set "Ignore All Global Filtering" in LocalFilter
                //LL: try: filtersLocal
                //let f0 = filters;
                //let filtersLocal = dataProperties.attrQueryFilter;

                const nullHandlingFromTheme = new NullHandling(theme).getBackendHandling();

                //LL: in WidgetStore:
                //const buildQueryResult = this.buildQuery(
                //    dataProperties, //widgetParameters,
                //    {}, //aqlParameters,
                //    timeZone,
                //    nullHandlingFromTheme,
                //    theme,
                //    dataProperties
                //);
                //private buildQuery(
                //    widgetParameters: IWidgetParameters,
                //    aqlParameters: IAQLParameters,
                //    timeZone,
                //    nullHandlingFromTheme,
                //    theme: IValuesCollection,
                //    //forPeriods?: boolean,
                //    _dataProperties?: any //LL: 09.08.23
                //): IBuildQueryResult {

                const ATTRIBUTE_SEPARATOR = '.'; // from EntityModelStore  function

                let buildQuery = () => {
                    //const attrQueries = dataProperties.attrQuery;
                    let attrQueries = dataProperties.attrQuery; //LL: 27.06.24
                    const cultureValues = null; //this.getCultureValues();
                    if (attrQueries == null || attrQueries.length === 0) {
                        return null;
                    }

                    const dataSourceID = dataProperties.dataSourceID;
                    //const attrib_refs: IAttributeReferenceExtended[] = [];
                    //const group_attribs: IAQLAttribute[] = [];
                    const attrib_refs: any[] = [];
                    const group_attribs: any[] = [];

                    let roles: any = {};

                    //LL: 27.06.24: sort attrQueries so that "groups" will come first
                    //  It is for proper "roles.index", because from Backend "groups" always come before "plain"
                    attrQueries = attrQueries.slice();
                    attrQueries.sort(function (a: any, b: any) {
                        const a_aggregateGroup = a.aggregateGroup;
                        const b_aggregateGroup = b.aggregateGroup;
                        if (a_aggregateGroup === AGGREGATIONS.GROUP && b_aggregateGroup !== AGGREGATIONS.GROUP) {
                            return -1; // a before b
                        }
                        if (a_aggregateGroup !== AGGREGATIONS.GROUP && b_aggregateGroup === AGGREGATIONS.GROUP) {
                            return 1;
                        }
                        return 0;
                    });

                    let keyAttribute: string;

                    for (let index = 0; index < attrQueries.length; index++) {
                        const attrQuery = attrQueries[index];

                        if (keyAttribute == null && attrQuery.attribute != null) {
                            const entity = EntityModelsStore.getAttributeEntityName(attrQuery.attribute);

                            keyAttribute = glob.EntityModelsStore.getKeyAttribute(entity, dataSourceID);

                            if (keyAttribute != null) {
                                keyAttribute = entity + ATTRIBUTE_SEPARATOR + keyAttribute;
                            }
                        }

                        let id = attrQuery.id;

                        if (
                            (attrQuery.attribute != null && attrQuery.attribute !== '') ||
                            attrQuery.expression != null
                        ) {
                            let dataReference: any; //IAttributeReferenceExtended;

                            if (attrQuery.attribute != null) {
                                dataReference = {
                                    attrib: attrQuery.attribute.split(ATTRIBUTE_SEPARATOR)
                                };
                            }

                            if (attrQuery.expression != null) {
                                //EVG 14.11.23: I cannot set correct scopeOptions here.
                                // Passing {} means that it uses default Period Filter or the first found.
                                const expression = globalState.expressionBindVariables(
                                    attrQuery.expression,
                                    dataSourceID,
                                    0, //this._state.options.runTimeWidgetID
                                    {}
                                );

                                if (expression == null) {
                                    continue;
                                }

                                dataReference = {
                                    syntaxTree: expression.syntaxTree,
                                    rettype: expression.rettype
                                };
                            }

                            if (attrQuery.sort != null && attrQuery.sort !== AGGREGATIONS.NONE) {
                                dataReference.sort = attrQuery.sortOrder;

                                if (attrQuery.sort === 'desc') {
                                    dataReference.sort_desc = true;
                                } else {
                                    dataReference.sort_desc = false;
                                }

                                dataReference.sort_values = attrQuery.sortOnValues;
                            }

                            //LL: 24.06.24: uncomment, new - see WidgetStore in GIT
                            if (attrQuery.intervals != null) {
                                //const intervalParameters = convertIntervalValueToAttrQueryParam(
                                //    attrQuery.intervals,
                                //    timeZone,
                                //    attrQuery.type,
                                //    theme,
                                //    cultureValues
                                //);
                                const intervalsWithFiscalMonth = globalState.applyDinamicFiscalMonth(
                                    attrQuery.intervals,
                                    {} //scopeOptions
                                );
                                const intervalParameters = convertIntervalValueToAttrQueryParam(
                                    intervalsWithFiscalMonth,
                                    timeZone,
                                    attrQuery.type,
                                    theme,
                                    cultureValues
                                );

                                dataReference = $.extend(true, dataReference, intervalParameters);
                            }

                            if (attrQuery.role != null) {
                                let role = attrQuery.role;

                                dataReference.role = role;

                                if (roles[role] == null) {
                                    roles[role] = {};
                                }
                                //  ??? index + 1, //Plus one because 0 column is for key value.
                                roles[role].index = index;
                            }

                            const aggregateGroup = attrQuery.aggregateGroup;

                            if (aggregateGroup !== AGGREGATIONS.GROUP) {
                                if (
                                    aggregateGroup != null &&
                                    aggregateGroup !== AGGREGATIONS.NONE &&
                                    aggregateGroup !== ''
                                ) {
                                    dataReference.agregate = attrQuery.aggregateGroup;
                                }
                                attrib_refs.push(dataReference);
                            } else {
                                group_attribs.push(dataReference);
                            }
                        }
                    }

                    const dataParameters: any = {
                        // IDataParameters
                        //...aqlParameters,
                        attrib_refs,
                        group_attribs,
                        dataSourceID: dataSourceID,
                        queryRootEntity: dataProperties.queryRootEntity,
                        nullHandling: nullHandlingFromTheme
                    };

                    if (dataProperties.limit != null && dataProperties.limit > 0) {
                        dataParameters.limit = dataProperties.limit;
                    } else {
                        delete dataParameters.limit;
                    }

                    dataParameters.maxNumberOfRecords = 1000;

                    if (dataProperties.distinct) {
                        dataParameters.distinct = true;
                    }

                    return {
                        dataParameters: dataParameters,
                        keyAttribute: keyAttribute,
                        roles: roles //LL: new Calendar
                    };
                };

                let buildQueryResult = buildQuery();

                if (buildQueryResult == null) {
                    //if (async) {
                    //    def.reject();
                    //} else {
                    //    this.emitChange();
                    //}
                    this.setState({ dataExternal: null, rolesExternal: null });
                    return;
                }

                const roles = buildQueryResult.roles;

                const dataParameters = buildQueryResult.dataParameters;
                const endlessScrolling = false;

                dataParameters.filter = filters;
                //dataParameters.filter = filtersLocal;//LL: try: filtersLocal  NO, use "Ignore GlobalFilter"

                //const keyAttribute = buildQueryResult.keyAttribute;
                const keyAttribute = null;

                //  dataParameters, buildQueryResult.keyAttribute, timeZone, theme
                //let getData = (): JQuery.Promise<IGetDataResult, IDataLoadRejectResult> => {
                let getData = () => {
                    const parametersHash = JSON.stringify(dataParameters);

                    // in BaseStore
                    //let result = this.getCachedDataDeferred<IGetDataResult, IDataLoadRejectResult>(
                    //    parametersHash,
                    //    dataParameters.maxCacheAge
                    //);
                    //let result = BaseStore.getCachedDataDeferred<any, any>(
                    //    parametersHash,
                    //    dataParameters.maxCacheAge
                    //);
                    //if (result != null) {
                    //    return result.promise();
                    //}

                    //let result = $.Deferred<IGetDataResult, IDataLoadRejectResult>();
                    let result = $.Deferred<any, any>();

                    //this.putCachedDataDeferred(parametersHash, result, parameters.sqlTimeOut);

                    const runTimeWidgetID = 0; //this.getRunTimeWidgetID();

                    let specialMainGroupHandling = false;
                    dataParameters.specialMainGroupHandling = specialMainGroupHandling;

                    const parametersToLoad = $.extend(true, {}, dataParameters);

                    const notHiddenAttrib_refs = _.filter(parametersToLoad.attrib_refs, (attr: any) => {
                        return attr.forHidden !== true;
                    });
                    const notHiddenGroup_attribs = _.filter(parametersToLoad.group_attribs, (attr: any) => {
                        return attr.forHidden !== true;
                    });

                    parametersToLoad.attrib_refs = notHiddenAttrib_refs;
                    parametersToLoad.group_attribs = notHiddenGroup_attribs;

                    const keyAttributeIsLoaded =
                        keyAttribute != null &&
                        parametersToLoad.group_attribs.length === 0 &&
                        !parametersToLoad.distinct;

                    if (keyAttributeIsLoaded) {
                        //If there is no grouping and Key Attribute exists, it is added to make selections work.
                        parametersToLoad.attrib_refs.unshift({
                            attrib: keyAttribute.split(ATTRIBUTE_SEPARATOR)
                        });
                    }

                    const fictivValue = 'no-value';

                    //if (
                    //    this._state.options.tab !== tab ||
                    //    this._state.options.workspace !== workspace ||
                    //    this._state.data.id !== widget

                    //glob.AQLQueries.loadData(parametersToLoad, this._state.options)
                    glob.AQLQueries.loadData(parametersToLoad, {})
                        .done((data) => {
                            let gridData = data; // temp

                            const dataResult = {
                                gridData: gridData,
                                age: data.age
                            };

                            result.resolve(dataResult);
                        })
                        .fail((responce) => {
                            result.reject(responce);
                        });

                    result.fail(() => {
                        //this.cleanDataCache(parametersHash);
                    });

                    return result.promise();
                };

                // dataParameters, buildQueryResult.keyAttribute, timeZone, theme
                getData()
                    .done((data) => {
                        let st = this.state;
                        this.setState({ dataExternal: data, rolesExternal: roles });
                    })
                    .fail(() => {
                        this.setState({ dataExternal: null, rolesExternal: null });
                    });

                //   fin buildQueryResult
            });
    }

    //LL: Attr Value List
    componentDidUpdate(prevProps, prevState) {
        let theme: any = this.props.themeObj; //LL: for ThemeField

        //LL: for external AQ
        let attrQueryExternal: any = null;
        if (theme != null) {
            attrQueryExternal = theme['widget-calendar-markers-dataQuery'];
        }

        let aqe: any = $.extend(true, {}, attrQueryExternal);

        //LL: for external AQ
        let toApply;
        if (attrQueryExternal != null && attrQueryExternal.toApply != null) {
            toApply = attrQueryExternal.toApply;
        }
        if (toApply === true) {
            console.log('CalendarMarkers componentDidUpdate toApply');
            delete aqe.toApply;
            //LL: no-no, loop  this.setState({ attrQueryExternal: aqe });
            console.log('CalendarMarkers componentDidUpdate GET DATA here');

            //LL: Validation ???

            //LL: see Module componentDidUpdate: this.loadData(widgetParameters, true);
            //   this.props.store.loadData_Holidays(widgetParameters, refresh, this.isInPrintMode());
            //  WidgetStore.loadData_Holidays   refresh=true   isInPrintMode=false
            this.loadData_PeriodTypes(aqe);

            return;
        } else {
            console.log('CalendarMarkers componentDidUpdate toApply NOT');
        }

        if (toApply != null) {
            delete aqe.toApply;
        }

        let st = this.state;
        const aqChanged = JSON.stringify(aqe) !== JSON.stringify(st.attrQueryExternal);

        if (aqChanged) {
            this.setState({ attrQueryExternal: aqe });
        }

        //if (prevProps.attribute !== this.props.attribute) {
        //    this.props.glob.EntityModelsActions.loadEntityValues(
        //        this.props.dataSourceID,
        //        theme,
        //        {
        //            attribute: this.props.attribute,
        //            loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES,
        //            runTimeWidgetID: undefined //EVG: I set it explicitly to show where it should be set when needed.
        //        }
        //    );
        //}
    }

    _onChange() {
        this.setState(getState.call(this));
    }

    processReorder(start, stop) {
        if (start === stop) {
            return;
        }

        let value = this.props.value.slice(0);

        let item = value.splice(start, 1);
        value.splice(stop, 0, item[0]);

        this.handleValueChange(value);
    }

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj) => {
        let arr = this.props.value.slice(0);

        //LL: name is set by attrValue
        obj.attrValue = null;
        obj.label = null;
        obj.name = '';
        obj.symbol = null;
        obj.useSymbolColor = false;
        obj.symbolColor = null;
        obj.useBorderColor = false;
        obj.borderColor = null;
        obj.pattern = null;
        obj.patternColor = null;
        obj.lineWidth = 4;

        //LL: Config.UseExternalDataQueryForPeriodTypes ???????
        //let evcExternal = this.props.entityCollectionExternal;
        //if (Config.UseExternalDataQueryForPeriodTypes === true) {
        //    if (evcExternal != null && evcExternal.labels != null) {
        //        let fnd: any = _.find(evcExternal.labels, function (labelObj: any) {
        //            return labelObj.value.toString() === val;
        //        });
        //        obj.label = fnd != null ? fnd.label : null; //'';
        //    }
        //
        //    if (evcExternal != null && evcExternal.displayValues != null) {
        //        let fnd = _.find(evcExternal.displayValues, (a:any, i) => {
        //            return (a.value.toString() === val);
        //        });
        //        obj.name = fnd != null ? fnd.displayValue : '';
        //    }
        //}

        if (this.state.forActualCalendar) {
            obj.dataSourceID = this.state.dataSourceID;
            obj.attribute = this.state.attribute;
            obj.entityName = this.state.entityName;
        } else {
            obj.dataSourceID = this.state.dataSourceID_pre;
            obj.entityName = this.state.entityName_pre;
        }

        arr.push(obj);
        this.handleValueChange(arr);
    };

    changeRow = (obj, i) => {
        //LL: Config.UseExternalDataQueryForPeriodTypes ???????

        if (this.state.forActualCalendar) {
            if (obj.dataSourceID == null) {
                obj.dataSourceID = this.state.dataSourceID;
            }
            if (obj.attribute == null) {
                obj.attribute = this.state.attribute;
            }
            if (obj.entityName == null) {
                obj.entityName = this.state.entityName;
            }
        } else {
            if (obj.dataSourceID == null) {
                obj.dataSourceID = this.state.dataSourceID_pre;
            }
            if (obj.entityName == null) {
                obj.entityName = this.state.entityName_pre;
            }
        }

        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    //LL: see Chart/ChartAxisField_inThemes.ts
    get_props_values() {
        //  was this.props.values
        let pv;
        if (this.props.options != null && this.props.options.widgetValues != null) {
            if (this.props.options.widgetTypeName === 'pdc-widget-calendar') {
                pv = this.props.options.widgetValues;
            }
        }
        return pv;
    }

    getColorItem(text, color, symbol, symbolColor) {
        let colorBox = (
            <ColorBoxField
                disabled={true}
                readOnly={true}
                onChange={null}
                value={color}
                themeObj={this.props.themeObj}
                hideTransparency={true}
                showText={true}
                glob={this.props.glob}
            />
        );
        return (
            <div style={{ display: 'flex', alignItems: 'center', padding: '2px', breakInside: 'avoid' }}>
                <div style={{ width: '100px' }}>{colorBox}</div>
                <span style={{ marginLeft: '6px' }}>{text}</span>
            </div>
        );
    }

    getDataSources(): any[] {
        //IDatasource[] {
        return this.props.glob.EntityModelsStore.getDataSources();
    }

    handleOnDataSourceChange = (selectedValue: string) => {
        const value = selectedValue != null ? parseInt(selectedValue) : null;

        //LL:
        //if (value != null) {
        //    // const entities:IDataLoadEntity[] =
        //    const entities:any[] = this.props.glob.EntityModelsStore.getEntitiesByDS(value); // 126 shifttype-118
        //    let a = entities;
        //}

        this.setState({ dataSourceID_pre: value, entityName_pre: null });
    };

    handleOnEntityChange = (selectedValue: string) => {
        if (selectedValue != null && selectedValue !== '') {
            let theme = this.props.themeObj; //LL: for ThemeField
            this.props.glob.EntityModelsActions.loadEntityValues(this.state.dataSourceID_pre, theme, {
                attribute: selectedValue,
                loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES,
                runTimeWidgetID: undefined //EVG: I set it explicitly to show where it should be set when needed.
            });
        }
        this.setState({ entityName_pre: selectedValue });
    };

    //LL: try for internal AQ
    handleOnAttrQueryChange = (value: any) => {
        let v = value;
        this.setState({ attrQuery: value });
    };

    //LL: try for internal AQ
    handleOnAttrQueryApply = (value: any) => {
        let v = value;
        this.setState({ attrQuery: value });
    };

    render() {
        let self = this;

        //LL: Data Calendar Markers     not here, in DidMount, DidUpdate ?
        let theme: any = this.props.themeObj;
        if (theme != null) {
            let DQ = theme['widget-calendar-markers-dataQuery'];
            let r = 0;
        }

        //LL: see
        //this.setState({
        //    forActualCalendar: forActualCalendar,
        //    dataSourceID: dataSourceID,
        //    attribute: attribute,
        //    entityName: attrRefEntityName
        //});
        let st = this.state;

        let forActualCalendar;
        let attribute; // person.^sickness_periods.shifttype
        let dataSourceID;
        let attrRefEntityName = '';

        if (st != null) {
            // null for 1st render
            forActualCalendar = false;
            if (st.forActualCalendar != null) {
                forActualCalendar = st.forActualCalendar;
            }
            dataSourceID = st.dataSourceID;
            attribute = st.attribute;
            attrRefEntityName = st.entityName;

            if (!forActualCalendar) {
                // this.setState({ dataSourceID_pre: value, entityName_pre: null });
                dataSourceID = st.dataSourceID_pre;
                attrRefEntityName = st.entityName_pre;
                //LL: first or last ?  Try, see in DidMount:
                //if (this.props.value != null) {
                //    let fnd = _.find(this.props.value, function (obj: any, i) {
                //        return (obj.dataSourceID != null && obj.entityName);
                //    });
                //    if (fnd != null) {
                //
                //    }
                //}
            }

            //LL: see this.setState({ dataExternal: data, rolesExternal: roles });
            //let de = st.dataExternal;
        }

        //LL: Attr Value List
        // see import { AttrValueColorSelect } from './AttrValueColorSelect'; // from platform/tsx/
        // AttrValueColorSelect.tsx:    _getListView  let attrValuesCollection = this._getDictionary();
        //      getEntityCollection
        //  let entityCollection = this.getEntityCollection();
        //  getEntityCollection() {
        //    return this.props.glob.AttrQueryStore.getEntityValueCollection(this.props.dataSourceID, {
        //        attribute: this.props.attribute,
        //        loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES
        //    });
        //}
        //  in call:  attribute={this.state.value.entityName}

        let entityCollection: any;
        let entityValuesElem;
        if (attrRefEntityName != null && attrRefEntityName !== '') {
            entityCollection = this.props.glob.AttrQueryStore.getEntityValueCollection(dataSourceID, {
                attribute: attrRefEntityName,
                loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES
            });
            //LL: { displayValues: [{displayValue:'_AAFSRT',value:-8358},...], values: ['_AAFSRT',...] } both 108 items
            //  values:
            //   98: "Sygdom - almindelig sygdom"
            //   99: "Sygdom - arbejdsskade"
            //  displayValues
            //   98: {displayValue:"Sygdom - almindelig sygdom", value:"-420"}

            //LL: commented, used in ...Row   Don't rem
            //if (entityCollection != null && entityCollection.displayValues != null) {
            //    //  none ?  not_set ? - below
            //    const options = _.map(entityCollection.displayValues, (obj:any, i) => {
            //        return (
            //            <option key={obj.value + '-' + i} value={obj.value}>
            //                {obj.displayValue}
            //            </option>
            //        );
            //    });
            //    //const displayVal = value.aggregateGroup || 'none';
            //    const displayVal = 'none';
            //
            //    //let selectElem = (
            //    //    <select
            //    //        className="form-control color-container-colorMethod"
            //    //        onChange={null}
            //    //        value={colorMethodVal}
            //    //    >
            //    //        {options}
            //    //    </select>
            //    //);
            //
            //    //  onChange={handleAggregateChange}>
            //    entityValuesElem =
            //        <SelectField value={displayVal} onChange={null}>
            //            <option key="none" value="none">
            //                {'none'}
            //            </option>
            //            {options}
            //        </SelectField>;
            //}
        }

        let defaultColorsElem;
        const legendItemW = '230px';
        let styleLegendItem: any = { width: legendItemW, paddingRight: '10px' };
        defaultColorsElem = (
            <div
                className="form-group"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    height: '100%',
                    breakInside: 'avoid',
                    pageBreakInside: 'avoid'
                }}
            >
                <div className="align-self-center" style={styleLegendItem}>
                    {this.getColorItem(
                        Config.Texts.Almindelig_sygdom_text,
                        Config.Colors.Almindelig_sygdom_BorderColor,
                        'x',
                        null
                    )}
                </div>
                <div className="align-self-center" style={styleLegendItem}>
                    {this.getColorItem(
                        Config.Texts.Arbejdsskade_text,
                        Config.Colors.Arbejdsskade_BorderColor,
                        'x',
                        null
                    )}
                </div>
                <div className="align-self-center" style={styleLegendItem}>
                    {this.getColorItem(Config.Texts.p56_sygdom_text, Config.Colors.p56_sygdom_BorderColor, null, null)}
                </div>
                <div className="align-self-center" style={styleLegendItem}>
                    {this.getColorItem(
                        Config.Texts.Ressourceforlob_text,
                        Config.Colors.Ressourceforlob_BorderColor,
                        'x',
                        null
                    )}
                </div>
                <div className="align-self-center" style={styleLegendItem}>
                    {this.getColorItem(
                        Config.Texts.Delvis_sygdom_text,
                        Config.Colors.Delvis_sygdom_BorderColor,
                        null,
                        null
                    )}
                </div>
                <div className="align-self-center" style={styleLegendItem}>
                    {this.getColorItem(
                        Config.Texts.Barns_sygdom_text,
                        Config.Colors.Barns_sygdom_BorderColor,
                        null,
                        null
                    )}
                </div>
                <div className="align-self-center" style={styleLegendItem}>
                    {this.getColorItem(
                        Config.Texts.Langtidssyg_sygdom_text,
                        Config.Colors.Langtidssyg_sygdom_BorderColor,
                        'X',
                        null
                    )}
                </div>
            </div>
        );

        //LL: set here and commented afterwards. Do not remove !
        let recommendedColorsElem;
        //let recommendedColorsElem = (
        //    <React.Fragment>
        //        <p style={{fontWeight:'bolder', paddingTop:'6px'}}>
        //            {'Recommended (default) Colors:'}
        //        </p>
        //        {defaultColorsElem}
        //    </React.Fragment>
        //);

        //LL: DataQuery for PeriodType values with Filter, actually standard AQL (4th query in Data Tab)
        let dataQueryContainerElem;
        let afValue: any = null; //this.handleOnDataSourceChange
        if (st != null) {
            // 1st render
            afValue = st.attrQuery;
        }

        let attributeContainerElem;
        if (Config.UseExternalDataQueryForPeriodTypes === true) {
            //LL: entityCollectionExternal
            //attributeContainerElem =
            //    <div style={{margin:"10px 0"}}>
            //        <p style={{border:'1px dotted #808080', paddingLeft:'3px'}}>
            //            <span style={{fontWeight:'bolder'}}>{'Attribute Values '}</span>
            //            {'stand for '}
            //            <span style={{fontWeight:'bolder'}}>{'Period Types '}</span>
            //            {'and correspond to Attribute defined in "Period Type" role in "Period Types" data query above.'}
            //        </p>
            //    </div>;
            //LL: 10.11.23: for <p> add className="explanation", rem border
            //  was <p style={{border:'1px dotted #808080', paddingLeft:'3px'}}>
            attributeContainerElem = (
                <div style={{ margin: '10px 0' }}>
                    <p style={{ paddingLeft: '3px' }} className="explanation">
                        <span style={{ fontWeight: 'bolder' }}>{'Period Types '}</span>
                        {'correspond to Attribute defined in "Period Type" role in "Period Types" data query above.'}
                    </p>
                </div>
            );
        } else {
            if (attribute != null) {
                // {'Attribute: ' + attribute + ' Attribute Type: '+ attrRefEntityName}
                //LL: max-width:400 - from .theme-field p   !!! ???  MUST RESET IN SASS <===============
                //    temp: <p style={{maxWidth:'none'}}>
                //LL: maxWidth:'none !important' is now in sass
                // <p>{'Attribute corresponds that of "Period Type" role in "Periods" data query'}</p>
                //attributeContainerElem =
                //    <div style={{margin:"10px 0 6px"}}>
                //        <p>{'Attribute Values correspond to Attribute defined in "Period Type" role in "Periods" data query'}</p>
                //        <p style={{border:'1px solid #111111', paddingLeft:'3px'}}>
                //            <span style={{fontWeight:'bolder'}}>{'Attribute: '}</span>
                //            {attribute}
                //            <span style={{fontWeight:'bolder', paddingLeft: '8px'}}>{' Attribute Type: '}</span>
                //            {attrRefEntityName}
                //        </p>
                //        {entityValuesElem}
                //        {recommendedColorsElem}
                //    </div>;
                attributeContainerElem = (
                    <div style={{ margin: '10px 0' }}>
                        <p style={{ border: '1px dotted #808080', paddingLeft: '3px' }}>
                            <span style={{ fontWeight: 'bolder' }}>{'Attribute Values '}</span>
                            {'stand for '}
                            <span style={{ fontWeight: 'bolder' }}>{'Period Types '}</span>
                            {'and correspond to Attribute defined in "Period Type" role in "Periods" data query, '}
                            <br />
                            <span style={{ fontWeight: 'bolder' }}>{'Attribute: '}</span>
                            {attribute}
                            <span style={{ fontWeight: 'bolder', paddingLeft: '8px' }}>{' Attribute Type: '}</span>
                            {attrRefEntityName}
                        </p>
                        {entityValuesElem}
                        {recommendedColorsElem}
                    </div>
                );
            } else if (!forActualCalendar) {
                //LL: WS or Application Options. Choose dataSourceID, attribute
                //   see AttributesField
                //   <DataSourceSelectorContainer
                //   import DataSourceSelectorContainer from '../../../../_common/platform/tsx/DataSourceSelectorContainer';
                //      datasources={ dataSources } from AttributesField
                const dataSources = this.getDataSources();

                // 0 : {dataSourceID: 1, name: 'Default'}
                // 1 : {dataSourceID: 2, name: 'DfK_DW'}
                let dataSourceOptions;
                if (dataSources != null && dataSources.length > 0) {
                    dataSourceOptions = _.map(dataSources, (ds: any, i) => {
                        return (
                            <option key={i} value={ds.dataSourceID}>
                                {ds.name}
                            </option>
                        );
                    });
                }
                const selectedDataSourceID =
                    this.state != null && this.state.dataSourceID_pre != null
                        ? this.state.dataSourceID_pre.toString()
                        : null;
                //const selectedDataSourceID = null;
                let selectDataSourceElem = (
                    <div style={{ width: '180px', paddingRight: '10px' }}>
                        <label>{'Data Source'}</label>
                        <SelectField value={selectedDataSourceID} onChange={this.handleOnDataSourceChange}>
                            {dataSourceOptions}
                        </SelectField>
                    </div>
                );

                // see EntityColorSelect.tsx
                //const entities: IDataLoadEntity[] = this.props.glob.EntityModelsStore.getEntitiesByDS(dataSourceID);
                const entities: any[] = this.props.glob.EntityModelsStore.getEntitiesByDS(selectedDataSourceID);
                //   array[129] 120: { ... name:'shifttype' ...}
                let entityOptions;
                if (entities != null && entities.length > 0) {
                    entityOptions = _.map(entities, (ent: any, i) => {
                        return (
                            <option key={i} value={ent.name}>
                                {ent.name}
                            </option>
                        );
                    });
                }
                const selectedEntity =
                    this.state != null && this.state.entityName_pre != null ? this.state.entityName_pre : null;
                let selectEntityElem = (
                    <div style={{ flex: '1 1 auto' }}>
                        <label>{'Entity/Attribute'}</label>
                        <SelectField value={selectedEntity} onChange={this.handleOnEntityChange}>
                            {entityOptions}
                        </SelectField>
                    </div>
                );

                attributeContainerElem = (
                    <div style={{ margin: '6px 0' }}>
                        <p style={{ fontWeight: 'bolder' }}>{'Select Attribute:'}</p>
                        <div style={{ display: 'flex' }}>
                            {selectDataSourceElem}
                            {selectEntityElem}
                        </div>

                        {entityValuesElem}
                        {recommendedColorsElem}
                    </div>
                );
            }
        }

        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let o = this.props.options;
        let builtinMarkers = [];
        if (o != null && o.builtinMarkers != null) {
            builtinMarkers = o.builtinMarkers;
        }
        //builtinMarkers: [
        //    {
        //        name: 'Sygd 1', code: 's1',  label: 'sygdom AAA',
        //        useBorderColor: true, borderColor: 'green',
        //        symbol: 'y', useSymbolColor: false, symbolColor: 'blue',
        //        pattern: 'diagonalLeft', patternBackColor: 'transparent', patternColor: 'coral'
        //    }
        //]

        //LL: see this.setState({ dataExternal: data, rolesExternal: roles });
        let entityCollectionExternal: any;
        if (Config.UseExternalDataQueryForPeriodTypes === true) {
            //LL: entityCollectionExternal
            if (st != null) {
                // 1st render
                let de: any = st.dataExternal;
                let re: any = st.rolesExternal;
                if (
                    re != null &&
                    de != null &&
                    de.gridData != null &&
                    de.gridData.result != null &&
                    de.gridData.result.length > 0
                ) {
                    let values = [];
                    let ids = []; //LL: 27.06.24
                    let displayValues = [];
                    let labels = [];

                    let ShiftType_index;
                    let ShiftLabel_index;
                    let ShiftId_index;
                    if (re.ShiftTypeT != null) {
                        ShiftType_index = re.ShiftTypeT.index;
                    }
                    if (re.ShiftLabelT != null) {
                        ShiftLabel_index = re.ShiftLabelT.index;
                    }
                    if (re.ShiftIdT != null) {
                        ShiftId_index = re.ShiftIdT.index;
                    }

                    // use index+1  !!!!  NO here

                    //LL:  ShiftLabel is mandatory ???   && ShiftLabel_index != null
                    if (ShiftType_index != null && ShiftId_index != null) {
                        _.each(de.gridData.result, (dataItem: any) => {
                            let shiftType = dataItem[ShiftType_index]; //dataItem[ShiftType_index + 1];
                            let shiftLabel;
                            if (ShiftLabel_index != null) {
                                shiftLabel = dataItem[ShiftLabel_index];
                            }
                            let shiftId = dataItem[ShiftId_index];

                            //values.push(shiftType);
                            //displayValues.push({value: shiftId, displayValue: shiftType});
                            //labels.push({value: shiftId, label: shiftLabel});

                            //LL: 27.06.24 multi values
                            let shiftType_exist = values.indexOf(shiftType) >= 0;
                            let shiftId_exist = ids.indexOf(shiftId) >= 0;
                            if (!(shiftType_exist && shiftId_exist)) {
                                values.push(shiftType);
                                ids.push(shiftId);
                                displayValues.push({ value: shiftId, displayValue: shiftType });
                                labels.push({ value: shiftId, label: shiftLabel });
                            }
                        });
                    }

                    entityCollectionExternal = { values: values, displayValues: displayValues, labels: labels };
                }
            }
        }

        let rows = _.map(this.props.value, function (obj: any, i) {
            let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'CalendarMarkersField');
            //LL: may be null, if just removed
            if (obj2 == null) {
                return null;
            }

            return (
                <CalendarMarkersFieldRow
                    key={i + '-' + obj2.name}
                    i={i}
                    value={obj2}
                    entityValueCollection={entityCollection}
                    entityCollectionExternal={entityCollectionExternal}
                    themeObj={self.props.themeObj}
                    onChange={self.changeRow}
                    onRemove={self.removeRow}
                    glob={self.props.glob}
                />
            );
        });

        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px

        return (
            <div className={'calendar-markers-field'}>
                <div className={'div-container'}>
                    <div className="calendar-markers-field-common"></div>
                    {attributeContainerElem}
                    {dataQueryContainerElem}
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        <tbody 
                            ref={(input) => {
                                this.references.tableBody = input;
                            }} //LL: 23.01.25
                        >
                            {rows}
                            <CalendarMarkersFieldRow
                                entityValueCollection={entityCollection}
                                entityCollectionExternal={entityCollectionExternal}
                                themeObj={this.props.themeObj}
                                onChange={this.addRow}
                                glob={this.props.glob}
                                empty={true}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

